/* Unbegun PDP Evolution — Build 1.1 */
(() => {
  const initQuantity = (root = document) => {
    root.querySelectorAll('[data-unbegun-quantity]').forEach((control) => {
      if (control.dataset.quantityReady === 'true') return;

      const input = control.querySelector('input[name="quantity"]');
      const minus = control.querySelector('[data-quantity-minus]');
      const plus = control.querySelector('[data-quantity-plus]');

      if (!input || !minus || !plus) return;

      const setValue = (value) => {
        const min = Number(input.min || 1);
        const next = Math.max(min, Number.isFinite(value) ? value : min);

        input.value = String(next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };

      minus.addEventListener('click', () => {
        setValue(Number(input.value || 1) - 1);
      });

      plus.addEventListener('click', () => {
        setValue(Number(input.value || 1) + 1);
      });

      input.addEventListener('change', () => {
        setValue(Number(input.value || 1));
      });

      control.dataset.quantityReady = 'true';
    });
  };

  const initDeliveryStatus = (root = document) => {
    root.querySelectorAll('[data-unbegun-delivery]').forEach((delivery) => {
      if (delivery.dataset.deliveryReady === 'true') return;

      const section = delivery.closest('[data-section-type="product"]');
      const form = delivery.closest('form[data-product-form]');
      const variantSelect = form && form.querySelector('[data-variant-select]');
      const stockMessage = delivery.querySelector('[data-unbegun-stock-message]');
      const isPreorder = delivery.dataset.isPreorder === 'true';

      if (!section || !form || !variantSelect || !stockMessage) return;

      const update = () => {
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        const isAvailable = Boolean(selectedOption && !selectedOption.disabled);

        stockMessage.hidden = isPreorder || !isAvailable;
      };

      variantSelect.addEventListener('change', update);

      form.querySelectorAll('select[name^="options["]').forEach((select) => {
        select.addEventListener('change', () => {
          window.requestAnimationFrame(update);
        });
      });

      update();
      delivery.dataset.deliveryReady = 'true';
    });
  };

  const init = (root = document) => {
    initQuantity(root);
    initDeliveryStatus(root);
  };

  document.addEventListener('DOMContentLoaded', () => init());

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();